export default __webpack_public_path__ + "static/media/wave_hello.1ad4b5ab.gif";